import { useState } from 'react'
import FontAwesomeIcon from './FontAwesomeIcon'

export default function FAQSection({ faqs, title = "Frequently Asked Questions" }) {
    const [openFaq, setOpenFaq] = useState(null)

    return (
        <section className="py-16 bg-gray-50">
            <div className="container mx-auto px-4 max-w-4xl">
                <h2 className="text-3xl font-bold text-center mb-12 text-safari-green">{title}</h2>

                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
                            <button
                                onClick={() => setOpenFaq(openFaq === index ? null : index)}
                                className="w-full text-left p-6 flex justify-between items-center hover:bg-gray-50 transition"
                            >
                                <span className="font-semibold text-lg pr-4">{faq.question}</span>
                                <FontAwesomeIcon
                                    icon={openFaq === index ? "fa-chevron-up" : "fa-chevron-down"}
                                    className="w-5 h-5 text-safari-green flex-shrink-0"
                                />
                            </button>
                            {openFaq === index && (
                                <div className="px-6 pb-6 text-gray-600">
                                    {faq.answer}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
